export default "__VITE_ASSET__B1_jsi$h__"